import { RevxButton } from 'components/RevxButton';
import { Paragraph, SectionHeading } from 'components/RevxTypography';
import { useTranslation } from 'react-i18next';
import { PRODUCT_REQUEST_URL } from 'utils/constants';
import './CompanyRequestProductCard.less';

/**
 * Closing card of the company gallery, shown to every visitor. Setting up a new base SKU is not
 * self-serve, so a buyer who cannot find their product asks for one through Zendesk - which also
 * tells sales which base SKUs are missing.
 */
export const CompanyRequestProductCard = () => {
  const { t } = useTranslation();
  return (
    <div className="gallery-request-product">
      <div>
        <SectionHeading className="gallery-request-product_title">
          {t('gallery.productRequest.title')}
        </SectionHeading>
        <Paragraph className="gallery-request-product_desc">
          {t('gallery.productRequest.description')}
        </Paragraph>
      </div>
      {/*
        The link sits inside the button rather than on it: antd renders a href button as an <a>,
        which does not centre its label the way a <button> does. antd covers the button with the
        anchor, so the whole thing stays clickable.
      */}
      <RevxButton size="large" type="primary">
        <a href={PRODUCT_REQUEST_URL} target="_blank" rel="noopener noreferrer">
          {t('gallery.productRequest.cta')}
        </a>
      </RevxButton>
    </div>
  );
};
